<template>
    <MainContainer :hideNavSidebar="true">
        <template #sidebar>
            <h3>Migrations-Tools</h3>
            <p>
                Achtung diese Funktionen sollten nur nach Absprache mit dem
                Administrator ausgeführt werden und können zu Inkonsistenzen der
                Daten führen!
            </p>
        </template>
        <h2>Migrations-Tools</h2>
        <b-row>
            <b-col cols="4">
                <b-button
                    v-for="(object, key, index) in data"
                    :key="key"
                    :variant="object.variant"
                    :disabled="object.busy"
                    block
                    @click="object.action"
                >
                    {{ object.label }}
                </b-button>
                <b-button
                    v-if="!mitgliedsbeitraege.deleted"
                    block
                    @click="migrateMitgliedsbeitraege"
                    variant="warning"
                >
                    Mitgliedsbeiträge importieren
                </b-button>
                <b-button
                    v-if="!buchungsstapel.deleted"
                    block
                    @click="migrateBuchungsstapel"
                    variant="warning"
                >
                    Buchungsstapel importieren
                </b-button>
            </b-col>
        </b-row>
        <div
            class="loading-modal container-fluid d-flex justify-content-center align-items-center p-3"
            v-if="mitgliedsbeitraege.busy || buchungsstapel.busy"
        >
            <div class="d-flex flex-column align-items-center">
                <h6 class="mb-3">Daten werden migriert. Bitte haben Sie etwas Geduld!</h6>
                <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
        </div>
    </MainContainer>
</template>

<script>
// @ is an alias to /src
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Toaster from "@/mixins/Toaster/Toaster";

const MigrationApi = ApiFactory.get("migration");

export default {
    name: "migration",
    mixins: [Toaster],
    components: {
        MainContainer
    },
    data() {
        return {
            data: {
                contacts: {
                    action: () => this.migrateContacts(),
                    busy: false,
                    variant: "warning",
                    label: "Kontakte importieren"
                },
                images: {
                    action: () => this.migrateImages(),
                    busy: false,
                    variant: "warning",
                    label: "Mitgliederbilder importieren"
                },
                probenplanTime: {
                    action: () => this.migrateProbenplanTime(),
                    busy: false,
                    variant: "warning",
                    label: "Probenplanzeiten importieren"
                },
                bemerkung: {
                    action: () => this.migrateBemerkung(),
                    busy: false,
                    variant: "warning",
                    label: "Bemerkung importieren"
                },
            },
            mitgliedsbeitraege: {
                busy: false,
                deleted: false
            },
            buchungsstapel: {
                busy: false,
                deleted: false
            }
        };
    },
    created() {
      this.deleteMitgliedsbeitraegeRoute();
      this.checkStapelbuchungRouteExistenz();
    },
    methods: {
        async migrateContacts() {
            this.data.contacts.busy = true;
            const response = await MigrationApi.contacts();
            if (response.ok) {
            }
            this.data.contacts.busy = false;
        },
        async migrateImages() {
            this.data.images.busy = true;
            const response = await MigrationApi.images();
            if (response.ok) {
            }
            this.data.images.busy = false;
        },
        async migrateProbenplanTime() {
            this.data.probenplanTime.busy = true;
            const response = await MigrationApi.images();
            if (response.ok) {
            }
            this.data.probenplanTime.busy = false;
        },
        async migrateBemerkung() {
            this.data.bemerkung.busy = true;
            const response = await MigrationApi.bemerkung();
            if (response.ok) {
            }
            this.data.bemerkung.busy = false;
        },
        async migrateMitgliedsbeitraege() {
            this.mitgliedsbeitraege.busy = true;
            const response = await MigrationApi.mitgliedsbeitraege();
            if(response.ok) {
                this.makeToast('Erfolgreiche Migration',
                `Die Daten wurden erfolgreich migriert.
                Es wurden ${response.json.insertedOPs} neue Einträge in offene Posten geschrieben.
                ${response.json.newOPsForUnpaidBeitraege} Datensätze wurden für noch offene Beitragszahlungen erzeugt`,
                'success');

                this.deleteMitgliedsbeitraegeRoute();
            } else {
                this.makeToast('Migration fehlgeschlagen',
                'Leider konnten keine Datensätze migriert werden. Bitte versuchen Sie es erneut',
                'danger');
            }
            this.mitgliedsbeitraege.busy = false;
        },
        async deleteMitgliedsbeitraegeRoute() {
            this.mitgliedsbeitraege.busy = true;
            const response = await MigrationApi.deleteMitgliedsbeitraegeMigration();

            if(response.ok) {
                if(response.json.collection[0] === 'deleted') {
                    this.mitgliedsbeitraege.deleted = true;
                }
            }

            this.mitgliedsbeitraege.busy = false;
        },
        async migrateBuchungsstapel() {
            this.buchungsstapel.busy = true;

            const response = await MigrationApi.migrateBuchungsstapel();

            if(response.ok) {
                this.makeToast('Erfolgreiche Migration',
                `Die Daten wurden erfolgreich migriert.
                Es wurden ${response.json.insertedBuchungsstapel} Buchungsstapel und ${response.json.insertedBuchungsvorlagen} Buchungsvorlagen importiert`,
                'success');

                this.deleteBuchungsstapelRoute();
            } else {
                this.makeToast('Migration fehlgeschlagen',
                    'Leider konnten keine Datensätze migriert werden. Bitte versuchen Sie es erneut',
                    'danger');
            }
            this.buchungsstapel.busy = false;
        },
        async deleteBuchungsstapelRoute() {
            const response = await MigrationApi.deleteBuchungsstapelMigration();

            if(response.ok) {
                if(response.json.collection[0] === 'deleted') {
                    this.buchungsstapel.deleted = true;
                }
            }

            this.buchungsstapel.busy = false;
        },
        async checkStapelbuchungRouteExistenz() {
            this.buchungsstapel.busy = true;

            const response = await MigrationApi.checkStapelbuchungRoute();

            if(response.ok) {
                if(response.json.collection[0] === 'deleted') {
                    this.buchungsstapel.deleted = true;
                }
            }

            this.buchungsstapel.busy = false;
        }


    }
};
</script>
